import { ToastsApi } from '@espoon-voltti/react-voltti/components/toaster'

let instance: ToastsApi | null = null

export function init(modals: ToastsApi) {
  instance = modals
}

export function get(): ToastsApi {
  return instance!
}
